import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '966566666048';
const WHATSAPP_MESSAGE = 'مرحباً، أريد الاستفسار عن منتجات قهوة أبهة';

export const WhatsAppWidget = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/pos')) return null; // cashier screen: no marketing widgets
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 left-6 z-[60] group md:bottom-6"
      aria-label="تواصل معنا عبر واتساب"
    >
      {/* Pulse effect */}
      <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-30" />
      
      {/* Main button */}
      <div className="relative flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-110">
        <MessageCircle className="w-7 h-7 text-white fill-white" />
      </div>
      
      {/* Tooltip */}
      <div className="absolute bottom-full left-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="bg-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
          <span className="text-sm font-medium text-gray-800">تواصل معنا عبر واتساب</span>
          <div className="absolute bottom-0 left-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white" />
        </div>
      </div>
    </a>
  );
};
